<template>
    <div>
        <el-form label-position="right" ref="form" :model="form.model" :rules="form.rules" :validate-on-rule-change="false" label-width="120px">
            <el-row class="bottom20">
                <el-row class="column-name" justify="start">
                    <span>计费调整</span>
                </el-row>
                <el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="客户" prop="customerId">
                                <customer-select v-model="form.model.customerId" @change="form.model.contractId = null"
                                                 :disabled="!editable" :filterable="true" :clearable="true" size="small">

                                </customer-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="合同" prop="contractId">
                                <contract-select v-model="form.model.contractId" :customer-id="form.model.customerId"
                                                 :disabled="!editable" :filterable="true" :clearable="true" size="small">

                                </contract-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="调整月份" prop="month">
                                <el-date-picker v-model="form.model.month" :disabled="!editable" size="small"
                                                type="month" value-format="yyyy-MM" >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="调整金额" prop="amount">
                                <el-input-number v-model="form.model.amount" :disabled="!editable" size="small"
                                                 :precision="2" :step="0.1" class="width100">
                                </el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="原因" prop="reason">
                                <el-input v-model="form.model.reason" :maxlength="30" placeholder="限30字符" :disabled="!editable" size="small">

                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="24" :lg="24">
                            <el-form-item label="备注" prop="desc">
                                <el-input v-model="form.model.desc" :maxlength="250" placeholder="限250字符" :disabled="!editable" size="small" type="textarea">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="记录人员" prop="realName">
                                <el-input v-model="form.model.vm_realName" :disabled="true" size="small">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                            <el-form-item label="记录时间" prop="inputTs">
                                <el-date-picker format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                                                v-model="form.model.ts" :disabled="true"
                                                type="datetime"
                                                placeholder="记录时间" size="small">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-row>
            </el-row>
        </el-form>
    </div>
</template>

<script>
    import _ from 'lodash'
    import {formatDate} from 'element-ui/src/utils/date-util'
    import Emitter from 'element-ui/src/mixins/emitter'
    import {merge} from "@/util/common"
    import BillingServer from '@/api/billing'

    import CustomerSelect from '@/views/billing/customer/component/customer.select'
    import ContractSelect from '@/views/billing/contract/component/contract.select'

    import {
        COMPONENT_DETAIL, COMPONENT_MAIN,
        OPERATION_DETAIL_SHOW, OPERATION_DETAIL_ADD, OPERATION_DETAIL_EDIT,
        MODEL_KEY_ID, FN_LIST_QUERY,
    } from "./contract.bill.adjust.common";
    import {AuthInfo} from "@/util/user/authInfo"
    export default {
        name: COMPONENT_DETAIL,
        componentName: COMPONENT_DETAIL,
        mixins: [Emitter],
        components: {CustomerSelect, ContractSelect},
        data() {
            return {
                operation: null,
                form: {
                    _init_model: {},
                    model: {},
                    rules: {
                        customerId: [
                            { required: true, message: '请选择客户', trigger: 'change' },
                        ],
                        contractId: [
                            { required: true, message: '请选择合同', trigger: 'change' },
                        ],
                        month: [
                            { required: true, message: '请填写调整月份', trigger: 'change' }
                        ],
                        amount: [
                            { required: true, message: '请填写调整金额', trigger: 'change' },
                        ],
                        reason: [
                            { required: true, message: '请填写原因', trigger: 'blur' },
                        ],
                    },
                },
            };
        },
        watch: {
            operation: {
                handler() {
                    this.$emit('operation-change', this.operation);
                }
            }
        },
        computed: {
            docType() {
                return this.form.model.content === 'POWER' ? "BILLINGPOWER" : "BILLINGNETWORK";
            },
            editable() {
                return this.operation === OPERATION_DETAIL_ADD || this.operation === OPERATION_DETAIL_EDIT;
            },
        },
        methods: {
            setFormModel(model) {
                this.form._init_model = merge(true, {}, model);
                this.form.model = merge(true, {}, model);
            },
            formIsDirty() {
                let initModel = this.form._init_model;
                let model = this.form.model;
                return !_.isEqual(initModel, model);
            },
            resetForm() {
                this.form.model = merge(true, {}, this.form._init_model);
            },
            async loadFormModel(id) {
                let res = await BillingServer.contractBillAdjust.get(id, {loading: true});
                if (!res.data.success) {
                    this.$message.error(res.data.responseMessage);
                    return ;
                }
                let detail = res.data.data;
                detail.vm_realName = AuthInfo.userRealName;
                this.setFormModel(detail);
            },
            async toShow(data) {
                await this.loadFormModel(data[MODEL_KEY_ID]);
                this.operation = OPERATION_DETAIL_SHOW;
            },
            async toAdd(data) {
                if (data == null) {
                    data = {};
                }
                this.setFormModel(data);
                this.operation = OPERATION_DETAIL_ADD;
            },
            async toEdit(data) {
                if (this.operation !== OPERATION_DETAIL_SHOW) {
                    await this.toShow(data);
                }
                this.operation = OPERATION_DETAIL_EDIT;
            },
            async saveAdd() {
                let valid = await this.$refs['form'].validate();
                if (valid) {
                    let data = this.form.model;
                    data.userId = AuthInfo.userId;
                    data.ts = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                    let res = await BillingServer.contractBillAdjust.add(data, {loading: true});
                    if (res.data.success) {
                        this.$message.success('保存成功！');
                        // this.setFormModel(res.data.data);
                        this.toShow(res.data.data);
                    } else {
                        this.$message.error(res.data.responseMessage);
                    }
                }
            },
            async saveEdit() {
                let valid = await this.$refs['form'].validate();
                if (valid) {
                    let data = this.form.model;
                    data.userId = AuthInfo.userId;
                    data.ts = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss');
                    let res = await BillingServer.contractBillAdjust.update(data['id'], data, {loading: true});
                    if (res.data.success) {
                        this.$message.success('保存成功！');
                        // this.setFormModel(res.data.data);
                        this.toShow(res.data.data);
                    } else {
                        this.$message.error(res.data.responseMessage);
                    }
                }
            },
            async toRemove(data) {
                data = data == null ? this.form.model : data;
                let res = await BillingServer.contractBillAdjust.delete(data['id'], {loading: true});
                if (res.data.success) {
                    this.$message.success('删除成功！');
                    this.dispatch(COMPONENT_MAIN, FN_LIST_QUERY);
                } else {
                    this.$message.error(res.data.responseMessage);
                }
            },
            cancelEdit() {
                this.toShow(this.form.model);
            },
        },
    }
</script>

<style scoped>

</style>